import React, { createContext, useEffect, useState, useRef } from "react";
import { isNull } from "App/utils/helpers";
import { FORM_RESET_STATE_WMS_REQ } from "../helpers";
import { RB_PENGAJUAN } from "App/constants";
import { DEFAULT_SHOW_BUTTON_SUBMIT } from "App/constants";

export const FormContext = createContext();

export const FormProvider = ({ type = "create", children, data, menu }) => {
  const oldFormData = useRef(null);
  const [showModalBarang, setShowModalBarang] = useState(false);
  const [showModalHistory, setShowModalHistory] = useState(false);
  const [showModalVerifikasi, setShowModalVerifikasi] = useState(false);
  const [formData, setFormData] = useState(() => {
    if (isNull(data)) {
      return FORM_RESET_STATE_WMS_REQ;
    } else {
      if (menu === RB_PENGAJUAN) {
        oldFormData.current = data;
        return data;
      } else {
        if (isNull(oldFormData.current)) {
          return FORM_RESET_STATE_WMS_REQ;
        } else {
          return oldFormData.current;
        }
      }
    }
  });

  const [validasi, setValidasi] = useState(false);
  const [filePDF, setFilePDF] = useState([]);
  const [filePDFFile, setFilePDFFile] = useState([]);
  const [listREQ, setListREQ] = useState([]);
  const [disabled, setDisabled] = useState(DEFAULT_SHOW_BUTTON_SUBMIT);
  // const [formData, setFormData] = useState(FORM_RESET_STATE_WMS_REQ)
  useEffect(() => {
    if (isNull(data)) {
      setFormData(FORM_RESET_STATE_WMS_REQ);
    } else {
      if (menu === RB_PENGAJUAN) {
        oldFormData.current = data;
        setFormData(data);
      } else {
        if (isNull(oldFormData.current)) {
          setFormData(FORM_RESET_STATE_WMS_REQ);
        } else {
          setFormData(oldFormData.current);
        }
      }
    }
  }, [data]); // eslint-disable-line
  return (
    <FormContext.Provider
      value={{
        formData,
        setFormData,
        listREQ,
        setListREQ,
        disabled,
        setDisabled,
        showModalBarang,
        setShowModalBarang,
        filePDF,
        setFilePDF,
        showModalVerifikasi,
        setShowModalVerifikasi,
        validasi,
        setValidasi,
        showModalHistory,
        setShowModalHistory,
        filePDFFile,
        setFilePDFFile,
      }}>
      {children}
    </FormContext.Provider>
  );
};
